import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactSortable } from "react-sortablejs";
// import moment from "moment";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Col,
  Form,
  Row,
  Spinner,
  Dropdown,
  OverlayTrigger,
  Tooltip,
  // NavDropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomNavbar from "../../../../components/CustomNavbar";
import SidebarClimate from "../../../../components/Clima/SidebarClimate";
import CampoPregunta from "../../../../components/Clima/Plantillas/pregunta";
import { getMeasurements } from "../../../../redux/climalaboral/measurements/actions";
import { getCategory } from "../../../../redux/climalaboral/category/actions";
import Categorie from "../../../../components/Clima/Plantillas/Modals/Categorie";
import Help from "../../../../components/Clima/Plantillas/Modals/Help";
import NewQuestion from "../../../../components/Clima/Plantillas/Modals/NewQuestion";
import ImportQuestion from "../../../../components/Clima/Plantillas/Modals/ImportQuestion";
import { useHistory } from "react-router-dom";
import {
  getPlantillaCuestionariosById,
  getPlantillaCuestionariosImport,
  saveMasiveCuestion,
} from "../../../../redux/climalaboral/plantillaCuestionario/action";

const PlantillasCreación = (props) => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");
  const [show, setShow] = useState(false);
  const [validatedPregunta, setValidatedPregunta] = useState(false);
  const [validatedCategoria, setValidatedCategoria] = useState(false);
  const [showModalCategoria, setShowModalCategoria] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [showModalPregunta, setShowModalPregunta] = useState(false);
  const [showModalPreguntasImport, setShowModalPreguntasImport] =
    useState(false);

  const [plantilla, setPlantilla] = useState(null);
  const [preguntasT, setPreguntasT] = useState(null);
  const [preguntasTImport, setPreguntasTImport] = useState([]);

  const [nombrePlantilla, setNombrePlantilla] = useState("");
  const [descripcionPlantilla, setDescripcionPlantilla] = useState("");

  const { surveyLoading, saveLoader, questionSaveLoader } = useSelector(
    (store) => store.plantillaCuestionario
  );

  const category = useSelector((store) => store.category.category);
  const categoryLoading = useSelector((store) => store.category.loading);

  const dispatch = useDispatch();
  const history = useHistory();

  const _getPlantillas = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getPlantillaCuestionariosImport({
        offset: offs,
        limit: lim,
        filter: filt,
      })
    );

  useEffect(() => {
    dispatch(
      getPlantillaCuestionariosById(
        parseInt(props.match.params.id),
        setPlantilla,
        setPreguntasT,
        setNombrePlantilla,
        setDescripcionPlantilla
      )
    );
    _getPlantillas();
    dispatch(getMeasurements({}));
    dispatch(getCategory({}));
  }, [props.match.params.id]);

  const onEditNewcuestionaire = () => {
    setShowModalCategoria(true);
    setValidatedCategoria(false);
  };

  const onAddPregunta = () => {
    setShowModalPregunta(true);
    setValidatedPregunta(false);
  };

  const onSubmit = () => {
    let _plantilla = plantilla;
    _plantilla.list_preguntas = preguntasT;
    _plantilla.nombre = nombrePlantilla;
    _plantilla.descripcion = descripcionPlantilla;
    var req = {
      cuestionario: _plantilla,
    };
    _plantilla.list_preguntas.map((item, index) => {
      req.cuestionario.list_preguntas[index].posicion = parseInt(index);
      item.list_Plantilla_Opciones.map((_item, _index) => {
        req.cuestionario.list_preguntas[index].list_Plantilla_Opciones[
          _index
        ].posicion = parseInt(_index);
      });
    });
    dispatch(saveMasiveCuestion(req, setPlantilla, setPreguntasT));
  };

  const importCuestions = () => {
    setShowModal(true);
    setShowModalPreguntasImport(false);
  };

  const openInfo = () => {
    setShowModalInfo(true);
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarClimate show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div>
            <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
              <h6 className="m-0 font-weight-bold text-uppercase d-flex justify-content-between align-items-center">
                Cuestionario
              </h6>
              <Form>
                <Row className="justify-content-end align-items-center flex-nowrap">
                  <Col xs="auto">
                    <Row className="flex-wrap justify-content-center align-items-center">
                      {!saveLoader && (
                        <span className="ml-3 mr-3" disabled>
                          <i className="material-icons">check_circle</i>
                          Cambios guardados...
                        </span>
                      )}
                      {saveLoader && (
                        <span className="ml-3 mr-3" disabled>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                          Guardando los cambios...
                        </span>
                      )}
                      <ButtonGroup className="flex-wrap justify-content-center align-items-center">
                        <OverlayTrigger
                          placement="auto"
                          overlay={
                            <Tooltip {...props}>Guardar cuestionario</Tooltip>
                          }
                        >
                          <Button
                            variant="link"
                            size="sm"
                            className="text-dark rounded-pill mx-1"
                            onClick={() => {
                              onSubmit();
                            }}
                          >
                            <i className="material-icons">save</i>
                          </Button>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="auto"
                          overlay={
                            <Tooltip {...props}>
                              Visualizar cuestionario
                            </Tooltip>
                          }
                        >
                          <Link
                            as="button"
                            variant="light"
                            className="text-dark rounded-pill mx-1"
                            onClick={() => {
                              props.history.push(
                                "/encuesta/vista-previa/" +
                                  props.match.params.id +
                                  "/" +
                                  props.match.params.Name +
                                  "/"
                              );
                            }}
                          >
                            <i className="material-icons">visibility</i>
                          </Link>
                        </OverlayTrigger>
                      </ButtonGroup>
                      <Dropdown size="sm">
                        <Dropdown.Toggle
                          as={ButtonGroup}
                          variant="secondary"
                          className="btn flex-wrap justify-content-center align-items-center"
                        >
                          <i className="material-icons">more_vert</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="py-0">
                          {/* <NavDropdown.Divider /> */}
                          <OverlayTrigger
                            placement="auto"
                            overlay={
                              <Tooltip {...props}>Guardar cuestionario</Tooltip>
                            }
                          >
                            <Dropdown.Item
                              className="d-flex justify-content-center align-items-center px-4 mt-2"
                              onClick={() => onSubmit()}
                            >
                              <i className="material-icons">save</i>
                              <Col sm="12" md="12" lg="12" xl="12">
                                Guardar
                              </Col>
                            </Dropdown.Item>
                          </OverlayTrigger>
                          {/* <NavDropdown.Divider /> */}
                          <OverlayTrigger
                            placement="auto"
                            overlay={<Tooltip {...props}>Ayuda de uso</Tooltip>}
                          >
                            <Dropdown.Item
                              className="d-flex justify-content-center align-items-center px-4"
                              onClick={() => openInfo()}
                            >
                              <i className="material-icons">help</i>
                              <Col sm="12" md="12" lg="12" xl="12">
                                Ayuda
                              </Col>
                            </Dropdown.Item>
                          </OverlayTrigger>
                          {/* <NavDropdown.Divider /> */}
                          <OverlayTrigger
                            placement="auto"
                            overlay={
                              <Tooltip {...props}>
                                Salir de la edición del cuestionario
                              </Tooltip>
                            }
                          >
                            <Dropdown.Item
                              className="d-flex justify-content-center align-items-center px-4 mb-2"
                              onClick={() => history.push("/cuestionarios")}
                            >
                              <i className="material-icons">reply</i>
                              <Col sm="12" md="12" lg="12" xl="12">
                                Salir
                              </Col>
                            </Dropdown.Item>
                          </OverlayTrigger>
                          {/* <NavDropdown.Divider /> */}
                        </Dropdown.Menu>
                      </Dropdown>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </div>
            <div className="px-2">
              <hr />
            </div>
          </div>
          {surveyLoading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            <>
              {plantilla ? (
                <Container fluid>
                  <div
                    className="
                      flex-wrap
                      justify-content-center
                      align-items-center
                      p-3
                      mb-5
                      bg-white
                      "
                  >
                    <Row>
                      <Col
                        xs="10"
                        sm="10"
                        md="9"
                        lg="9"
                        xl="9"
                        style={{ margin: "auto" }}
                      >
                        <Row>
                          <Col md="12" className="ml-auto mr-auto">
                            <Form.Group
                              className="shadow-sm mb-5 bg-white rounded"
                              style={{ border: "1px solid #ced4da" }}
                            >
                              <div className="estiloFondo">
                                <div className="b pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-center align-items-center">
                                  <Button
                                    size="sm"
                                    className="btn rounded-circle"
                                    disabled
                                  >
                                    <i
                                      className="material-icons"
                                      style={{ transform: "rotate(90deg)" }}
                                    >
                                      drag_indicator
                                    </i>
                                  </Button>
                                </div>
                              </div>
                              <div className="pl-3 pr-3 pb-3 pt-3">
                                <Form>
                                  <Row>
                                    <Form.Group as={Col} className="mb-3">
                                      <Form.Label column sm="12" md="12">
                                        Título del cuestionario:
                                      </Form.Label>
                                      <Form.Control
                                        id="titulo"
                                        name="titulo"
                                        className="rounded-pill"
                                        required
                                        // defaultValue={
                                        //   plantilla && plantilla.nombre
                                        //     ? plantilla.nombre
                                        //     : ""
                                        // }
                                        value={nombrePlantilla}
                                        onChange={(e) => {
                                          // e.preventDefault();
                                          // setTimeout(() => {
                                          setNombrePlantilla(
                                            e.currentTarget.value
                                          );
                                          // }, 1000);
                                        }}
                                        type="text"
                                        pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9@$¿?¡\-_%#]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9@$¿?¡\-_%#]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9@$¿?¡\-_%#]+$"
                                        placeholder="Titulo del cuestionario"
                                      ></Form.Control>
                                      <Form.Control.Feedback type="invalid">
                                        **Campo requerido
                                      </Form.Control.Feedback>
                                      <Form.Control.Feedback type="invalid">
                                        **Solo admite letras,numeros y los
                                        siguientes caracteres @$¿?¡\-_%#
                                      </Form.Control.Feedback>
                                    </Form.Group>
                                  </Row>
                                  <Row>
                                    <Form.Group as={Col} className="mb-3">
                                      <Form.Label className="ml-2">
                                        Descripción del cuestionario:
                                      </Form.Label>
                                      <Form.Control
                                        id="descripcionP"
                                        name="descripcionP"
                                        as="textarea"
                                        required
                                        // onChange={onSubmitD}
                                        // defaultValue={
                                        //   plantilla && plantilla.descripcion
                                        //     ? plantilla.descripcion
                                        //     : ""
                                        // }
                                        value={descripcionPlantilla}
                                        onChange={(e) => {
                                          // e.preventDefault();
                                          // setTimeout(() => {
                                          setDescripcionPlantilla(
                                            e.currentTarget.value
                                          );
                                          // }, 1000);
                                        }}
                                        pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9@$¿?¡\-_%#]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9@$¿?¡\-_%#]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9@$¿?¡\-_%#]+$"
                                        placeholder="Descripción del cuestionario"
                                      ></Form.Control>
                                      <Form.Control.Feedback type="invalid">
                                        **Campo requerido
                                      </Form.Control.Feedback>
                                      <Form.Control.Feedback type="invalid">
                                        **Solo admite números y letras
                                      </Form.Control.Feedback>
                                    </Form.Group>
                                  </Row>
                                </Form>
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="ml-auto mr-auto">
                          <Col md="12">
                            <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
                              <h6 className="font-weight-bold text-uppercase">
                                Preguntas
                              </h6>
                            </div>
                            <div className="px-2">
                              <hr />
                            </div>
                          </Col>
                        </Row>
                        {!preguntasT ? (
                          <Alert className="my-4" variant="info">
                            Aún no hay preguntas registradas, comience agregando
                            algunas.
                          </Alert>
                        ) : (
                          <>
                            <Row>
                              <Col md="12" className="ml-auto mr-auto">
                                <ReactSortable
                                  tag="span"
                                  list={preguntasT}
                                  setList={setPreguntasT}
                                  group="preguntas"
                                  animation={200}
                                  handle=".buttonGrab"
                                  delayOnTouchOnly={true}
                                  forceFallback={true}
                                >
                                  {preguntasT.map((item, _index) => (
                                    <div key={item.id}>
                                      <CampoPregunta
                                        data={plantilla ? plantilla : []}
                                        length={0}
                                        pregunta={item}
                                        preguntas={preguntasT}
                                        setPreguntas={setPreguntasT}
                                        index={parseInt(_index)}
                                      />
                                    </div>
                                  ))}
                                </ReactSortable>
                              </Col>
                            </Row>
                          </>
                        )}
                      </Col>
                      <Col
                        xs="1"
                        sm="1"
                        md="1"
                        lg="1"
                        xl="1"
                        className="ml-auto 
                                mr-auto
                                "
                        style={{
                          padding: "0",
                          position: "fixed",
                          right: "2rem",
                        }}
                      >
                        <Col
                          xs="12"
                          sm="12"
                          md="6"
                          lg="6"
                          xl="6"
                          className="estiloFondo shadow bg-white rounded m-auto"
                          style={{
                            border: "1px solid #ced4da",
                            height: "15rem",
                          }}
                        >
                          <Form.Group style={{ margin: "auto" }}>
                            <Row className="d-flex flex-wrap justify-content-center align-items-center">
                              <Col
                                xs="auto"
                                style={{ padding: "0", textAlign: "center" }}
                              >
                                <Row>
                                  <ButtonGroup>
                                    <OverlayTrigger
                                      placement="auto"
                                      overlay={
                                        <Tooltip {...props}>
                                          Agregar pregunta
                                        </Tooltip>
                                      }
                                    >
                                      <Button
                                        // variant="light"
                                        size="sm"
                                        className="rounded-circle mt-3"
                                        style={{ padding: "0" }}
                                        onClick={() => onAddPregunta()}
                                      >
                                        <i className="material-icons">
                                          add_circle_outline
                                        </i>
                                      </Button>
                                    </OverlayTrigger>
                                  </ButtonGroup>
                                </Row>
                                <Row>
                                  <ButtonGroup>
                                    <OverlayTrigger
                                      placement="auto"
                                      overlay={
                                        <Tooltip {...props}>
                                          Guardar cuestionario
                                        </Tooltip>
                                      }
                                    >
                                      <Button
                                        // variant="link"
                                        size="sm"
                                        className="rounded-circle mt-3"
                                        style={{ padding: "0" }}
                                        onClick={() => onSubmit()}
                                      >
                                        <i className="material-icons">save</i>
                                      </Button>
                                    </OverlayTrigger>
                                  </ButtonGroup>
                                </Row>
                                <Row>
                                  <ButtonGroup>
                                    <OverlayTrigger
                                      placement="auto"
                                      overlay={
                                        <Tooltip {...props}>
                                          Importar preguntas
                                        </Tooltip>
                                      }
                                    >
                                      <Button
                                        size="sm"
                                        className="rounded-circle mt-3"
                                        style={{ padding: "0" }}
                                        onClick={() => importCuestions()}
                                      >
                                        <i className="material-icons">
                                          article
                                        </i>
                                      </Button>
                                    </OverlayTrigger>
                                  </ButtonGroup>
                                </Row>
                                <Row>
                                  <ButtonGroup>
                                    <OverlayTrigger
                                      placement="auto"
                                      overlay={
                                        <Tooltip {...props}>
                                          Editar categoria
                                        </Tooltip>
                                      }
                                    >
                                      <Button
                                        size="sm"
                                        className="rounded-circle mt-3"
                                        style={{ padding: "0" }}
                                        onClick={() => onEditNewcuestionaire()}
                                      >
                                        <i className="material-icons">
                                          emoji_objects
                                        </i>
                                      </Button>
                                    </OverlayTrigger>
                                  </ButtonGroup>
                                </Row>
                                <Row>
                                  <ButtonGroup>
                                    <OverlayTrigger
                                      placement="auto"
                                      overlay={
                                        <Tooltip {...props}>
                                          Visualizar cuestionario
                                        </Tooltip>
                                      }
                                    >
                                      <Link
                                        as="button"
                                        size="sm"
                                        className="text-light rounded-circle mt-3"
                                        style={{ padding: "0" }}
                                        onClick={() => {
                                          props.history.push(
                                            "/encuesta/vista-previa/" +
                                              props.match.params.id +
                                              "/" +
                                              props.match.params.Name +
                                              "/"
                                          );
                                        }}
                                      >
                                        <i className="material-icons">
                                          visibility
                                        </i>
                                      </Link>
                                    </OverlayTrigger>
                                  </ButtonGroup>
                                </Row>
                              </Col>
                            </Row>
                          </Form.Group>
                        </Col>
                      </Col>
                    </Row>
                  </div>
                </Container>
              ) : (
                <Alert className="my-4 mx-1" variant="info">
                  Aún no hay cuestionario registrado.
                </Alert>
              )}
            </>
          )}
        </Container>
        <ImportQuestion
          showModal={showModal}
          showModalPreguntasImport={showModalPreguntasImport}
          setShowModalPreguntasImport={setShowModalPreguntasImport}
          setShowModal={setShowModal}
          getAPlantillas={_getPlantillas}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setFilter={setFilter}
          setOffset={setOffset}
          offset={offset}
          limit={limit}
          setLimit={setLimit}
          preguntasTImport={preguntasTImport}
          id={props.match.params.id}
          preguntas={preguntasT}
          setPreguntas={setPreguntasT}
        />
        <NewQuestion
          showModalPregunta={showModalPregunta}
          setShowModalPregunta={setShowModalPregunta}
          setValidatedPregunta={setValidatedPregunta}
          validatedPregunta={validatedPregunta}
          questionSaveLoader={questionSaveLoader}
          id={props.match.params.id}
          plantilla={plantilla}
          preguntas={preguntasT}
          setPreguntas={setPreguntasT}
        />
        <Categorie
          showModalCategoria={showModalCategoria}
          setShowModalCategoria={setShowModalCategoria}
          validatedCategoria={validatedCategoria}
          categoryLoading={categoryLoading}
          plantilla={plantilla}
          setPlantilla={setPlantilla}
          category={category}
          saveLoader={saveLoader}
        />
        <Help
          showModalInfo={showModalInfo}
          setShowModalInfo={setShowModalInfo}
        />
      </div>
    </>
  );
};

export default PlantillasCreación;
